import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'input',
    'default',
    'uploaded',
    'error',
  ];

  connect() {
    // Make the entire div clickable to trigger file input
    this.element.addEventListener('click', this.handleClick.bind(this));

    // Handle drag and drop events
    this.element.addEventListener('dragover', this.handleDragOver.bind(this));
    this.element.addEventListener('dragleave', this.handleDragLeave.bind(this));
    this.element.addEventListener('drop', this.handleDrop.bind(this));

    // Listen to input changes
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener(
        'change',
        this.handleFileChange.bind(this)
      );
    }
  }

  handleClick(event) {
    // Don't trigger if clicking on the input itself
    if (event.target === this.inputTarget) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.hasInputTarget) {
      this.inputTarget.click();
    }
  }

  handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.add('border-primary');
  }

  handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.remove('border-primary');
  }

  handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.remove('border-primary');

    const files = event.dataTransfer.files;
    if (files.length > 0 && this.hasInputTarget) {
      // Set the files on the input
      this.inputTarget.files = files;

      // Trigger change event
      const changeEvent = new Event('change', { bubbles: true });
      this.inputTarget.dispatchEvent(changeEvent);
    }
  }

  handleFileChange() {
    if (this.inputTarget.files && this.inputTarget.files.length > 0) {
      const file = this.inputTarget.files[0];
      this.showUploadedState(file);
    } else {
      this.showDefaultState();
    }
  }

  showUploadedState(file) {
    this.hideAllStates();

    if (this.hasUploadedTarget) {
      this.uploadedTarget.classList.remove('d-none');
      const fileNameElement = this.uploadedTarget.querySelector(
        '[data-dropzone-target="fileName"]'
      );
      if (fileNameElement) fileNameElement.textContent = file.name;
    }
  }

  showDefaultState() {
    this.hideAllStates();
    if (this.hasDefaultTarget) this.defaultTarget.classList.remove('d-none');
  }

  hideAllStates() {
    if (this.hasDefaultTarget) this.defaultTarget.classList.add('d-none');
    if (this.hasUploadedTarget) this.uploadedTarget.classList.add('d-none');
    if (this.hasErrorTarget) this.errorTarget.classList.add('d-none');
  }
}
